function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Send({
  width = 19,
  height = 20,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.64 8.668L2.516.375A1.463 1.463 0 00.352 1.658v16.585a1.463 1.463 0 002.165 1.283l15.122-8.293a1.463 1.463 0 000-2.565zM1.814 18.243v-7.317h6.341a.732.732 0 000-1.463H1.815V1.658L16.937 9.95 1.815 18.243z",
    fill: "#000"
  }));
}
//# sourceMappingURL=Send.js.map